export const conhecaOPastejoContent = {
  titlePrefix: "Conheça o",
  titleBrand: "pastejo",
  subtitle:
    "Sistema de\nperformance\noperacional para a\npecuária de corte.",
  ctaBannerBold: "MAIS CONTROLE, EFICIÊNCIA E RESULTADO",
  ctaBannerRest: "NA OPERAÇÃO PECUÁRIA.",
} as const;
